export default {
  toolbar: [
    "bold",
    "italic",
    "underline",
    "strikeThrough",
    "justifyLeft",
    "justifyCenter",
    "justifyRight",
    "justifyFull",
    "indent",
    "outdent",
    "insertOrderedList",
    "insertUnorderedList",
  ],
  fontName: [
    { val: "arial" },
    { val: "arial black" },
    { val: "times new roman" },
    { val: "Courier New" },
  ],
  fontSize: ["10px", "12px", "14px", "16px", "18px", "20px", "24px", "28px", "32px", "36px"],
  uploadUrl: "",
  id: "",
  classList: [],
};
